import React, { use, useEffect } from "react";
import getTranslatedField from "./getTranslatedField";
import createAlias from "./createAlias";
import { link } from "pages/Event";

const BRANCH_IO_KEY = "key_live_pxtoyqQKJS5ozFf9RGJ8EhgarBfb6ZRm";
const BRANCH_IO_DOMAIN = "zippertic.app.link";

// Branch.io configuration
const BRANCH_CONFIG = {
    BRANCH_KEY: BRANCH_IO_KEY,
    BASE_URL: `https://${BRANCH_IO_DOMAIN || 'zippertic.app.link'}`,
    API_ENDPOINT: 'https://api2.branch.io/v1/url'
};

const linkData = ({ deepPath, params, fullUrl, finalEventName, eventDescription, eventThumbnail, campaign }) => ({
    branch_key: BRANCH_CONFIG.BRANCH_KEY,
    channel: 'web',
    feature: 'sharing',
    campaign,
    tags: ['event'],
    data: {
        // Deep link data
        $deeplink_path: deepPath,
        $fallback_url: `${fullUrl}`,
        $desktop_url: `${fullUrl}`,
        $ios_url: `${fullUrl}`,
        $android_url: `${fullUrl}`,

        //ios deferred
        $ios_nativelink: true,

        // Custom data
        ...(params ? params : {}),
        original_url: `${fullUrl}`,

        // Open Graph tags for social sharing
        $og_title: finalEventName || 'Join this amazing event!',
        $og_description: eventDescription,
        $og_image_url: eventThumbnail,

        // Analytics data
        '~channel': 'web',
        '~feature': 'sharing',
        '~tags': ['event']
    }
});

export default function useDefferedLink({ event, pid = null /*promoter id*/ }) {
    const url = new URL(document.baseURI);

    const [defferedUrl, setDefferedUrl] = React.useState(null);

    useEffect(() => {
        if (!event?.id) {
            return;
        }

        const finalEventName = getTranslatedField(event?.translations, 'name') || event?.name;
        const eventDescription = getTranslatedField(event?.translations, 'description') || event?.description || 'Don\'t miss out on this awesone event';
        const eventThumbnail = event?.thumbnail || 'https://zippertic.se/static/media/White%2024.b0af6a8e.svg';

        const alias = createAlias(finalEventName, event.id, pid ? `promo${pid.toString()}` : null);

        const data = linkData({
            deepPath: link(event.id),
            params: {
                id: event.id.toString(),
                promoter: pid ? pid.toString() : null
            },
            fullUrl: url.origin + link(event.id),
            finalEventName,
            eventDescription,
            eventThumbnail,
            campaign: 'promo_widget' + (pid ? `_promoter_${pid}` : '')
        });

        fetch(BRANCH_CONFIG.API_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ...data, alias })
        })
            .then(response => {
                if (!response.ok) {
                    // If it's an alias conflict, the link already exists - just return it
                    if (response.status === 400) {
                        const existingUrl = `${BRANCH_CONFIG.BASE_URL}/${alias}`;
                        console.log('Alias conflict detected - link already exists, returning existing URL:', existingUrl);
                        setDefferedUrl(existingUrl);
                        return;
                    } else {
                        throw new Error(`Branch API error: ${response.status}`);
                    }
                }
                return response.json();
            })
            .then(data => {
                setDefferedUrl(data.url);
            })
            .catch((error) => {
                console.error('Error creating Branch.io link:', error);
                return url.origin + link(event.id);
            });

    }, [event]);

    // const event_url = defferedLink(url.origin+link(id));
    if (!event?.id) {
        return null;
    };

    return defferedUrl;
}